<div class="view-chargement" *ngIf="estVisible()">
  <div>
    <div class="spinner-border" role="status" style="width: 50px;height:50px;"></div>
  </div>

  <p>Chargement ...</p>
</div>
